export default __webpack_public_path__ + "static/media/banner-astronomy.a5063af6.jpeg";